function chunkArray(array: any[], number_of_chunks: number) {
  let chunkLength = Math.max(array.length / number_of_chunks, 1);
  let chunks = [];

  for (let i = 0; i <= number_of_chunks; i++) {
    if (chunkLength * (i + 1) <= array.length) {
      chunks.push(array.slice(chunkLength * i, chunkLength * (i + 1)));
    } 
  }
  
  return chunks;
}

export default chunkArray;
